import { render, staticRenderFns } from "./TopNews.vue?vue&type=template&id=117655b2&scoped=true&"
import script from "./TopNews.vue?vue&type=script&lang=js&"
export * from "./TopNews.vue?vue&type=script&lang=js&"
import style0 from "./TopNews.vue?vue&type=style&index=0&id=117655b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117655b2",
  null
  
)

component.options.__file = "TopNews.vue"
export default component.exports